import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Icon } from '@codex-brightworld/icons';

const Panel = styled.div`
  ${({
    theme
  }) => css`
    margin: 16px 0;
    padding: 24px 16px;
    border: 1px solid ${theme.colors.neutral.grey[2]};
    border-radius: 7px;    margin-bottom: 10px;
  `};
`;

const Bar = styled.div`
  ${({
    theme,
    active
  }) => css`
    position: relative;
    display: block;
    padding: ${theme.spacing[3]} 17.5px ${theme.spacing[3]} 30px;
    outline: 0;
    background-color: ${theme.colors.neutral.white};
    font-size: 18px;
    line-height: 1.22;
    cursor: pointer;
    transform: translate3d(0, 0, 0);
    transition: background 0.2s;
    color: ${theme.colors.neutral.currysBlack};

    ${Icon} {
      float: right;
      transform: rotate(${active ? 90 : 0}deg);
      width: 24px;
      height: 24px;
      margin-top: -2px;
      margin-right: -5px;
      transition: all 0.2s;
      color: ${theme.colors.link.default};
    }
  `};
`;

/**
 * @tags styled, accordion
 */
class AccordionPanel extends Component {

  panelRef = React.createRef();

  componentDidMount() {
    const { props } = this;

    if (props.active) {
      setTimeout(() => {
        this.scrollToSelf();
      }, 10);
    }
  }

  scrollToSelf() {
    if (typeof window === 'undefined') {
      return;
    }

    const { panelRef, props } = this;

    if (props.active && panelRef.current !== null) {
      const elementTop = panelRef.current.getBoundingClientRect().top;
      const documentTop = document.documentElement.scrollTop;
      const scrollFromTop = (elementTop + documentTop) - props.scrollOffset;

      window.scrollTo(0, scrollFromTop);
    }
  }

  render() {
    const { props } = this;

    return (
      <Panel
        {...props}
        ref={this.panelRef}
        data-qa={props.qa}
      >
        <Bar active={props.active} onClick={props.onClick}>
          <Icon icon="arrowright" />
          {props.title}
        </Bar>

        {props.active && (
          <div>
            {props.children}
          </div>
        )}
      </Panel>
    );
  }
}

AccordionPanel.displayName = 'AccordionPanel';

AccordionPanel.propTypes = {
  panelId: PropTypes.number.isRequired,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  scrollOffset: PropTypes.number.isRequired,
  qa: PropTypes.string
};

AccordionPanel.defaultProps = {
  active: false,
  onClick: () => {},
  qa: undefined
};

/** @component */
export default AccordionPanel;
